export default function(_DSB,_CONTEXT={}){

  return function(data,target)
  {
    let function_generate_a_post_widget = function(widget)
    {
      let component = false;
      if(`type` in widget)
      {
          switch(widget.type)
          {
              case "WP_Widget_Text":
                      component = document.createElement("div");
                      component.innerHTML = widget.data;
                  break;
              default:
                  break;
          }
      }
      return component;
    }

    let function_generate_post_widgets = function(post_widgets,body)
    {
      _DSB.log('debug','function_generate_post_widgets',"Setting post_widgets...");
      let has_widgets = false;
      let cell_count = 5;
      if(`grid` in post_widgets)
      {
          let _post_widgets = document.createElement("div");
          _post_widgets.setAttribute('class','post_widgets');
          for(let i in post_widgets.grid)
          {
              let row_settings = false;
              if((`settings` in post_widgets) && (`rows` in post_widgets.settings))
              {
                  if(grid_row in post_widgets.settings.rows)
                  {
                      row_settings = post_widgets.settings.rows[grid_row];
                  }
              }

              let grid_row = document.createElement("div");
              grid_row.setAttribute('class','post_widgets-row');
              let grid_cell = Array.apply(null, Array(5)).map(function () {});
              delete grid_cell[0];

              for(let ii in grid_cell)
              {
                  grid_cell[ii] = document.createElement("div");
                  grid_cell[ii].setAttribute('class','post_widgets-item');
                  if(!(ii in post_widgets.grid[i]))
                  {
                      grid_cell[ii].innerHTML = `&nbsp;`;
                      if(row_settings && (`fill` in row_settings) && (row_settings.fill == 'yes'))
                      {
                          delete grid_cell[ii];
                      }
                  }
                  else
                  {
                      if(`span` in post_widgets.grid[i][ii] && post_widgets.grid[i][ii].span>1)
                      {
                          grid_cell[ii].setAttribute('style','flex-grow:'+post_widgets.grid[i][ii].span);
                          let del_count = (Number(post_widgets.grid[i][ii].span) - 1);
                          let del_start = (Number(ii) + 1);
                          for (let span_i = del_start; span_i < 5; span_i++)
                          {
                              if(del_count<1)
                              {
                                  break;
                              }
                              delete grid_cell[span_i];
                              del_count--;
                          }
                      }
                      let thisWidget = function_generate_a_post_widget(post_widgets.grid[i][ii]);
                      if(thisWidget)
                      {
                          grid_cell[ii].innerHTML = ``;
                          grid_cell[ii].append(thisWidget);
                      }
                      else
                      {
                          grid_cell[ii].innerHTML = `&nbsp;`;
                          if(row_settings && (`fill` in row_settings) && (row_settings.fill == 'yes'))
                          {
                                  delete grid_cell[ii];
                          }
                      }

                  }
              }

              for( let aCell in grid_cell)
              {
                  grid_row.append(grid_cell[aCell]);
              }
              _post_widgets.append(grid_row);
              body.append(_post_widgets);
              has_widgets = true;
          }
      }
      return has_widgets;
    }
    if(typeof data === 'object' && data!== null && `post_widgets` in data && typeof data.post_widgets === 'object')
    {
      if(target instanceof HTMLElement)
      {
        return function_generate_post_widgets(data.post_widgets,target);
      }
      else
      {
        let returned_html=document.createElement('div');
        if(function_generate_post_widgets(data.post_widgets,returned_html))
        {
          return returned_html.children;
        }
      }
    }
    return false;
  }
}
